module.exports = __webpack_public_path__ + "img/-s-pic_product zdyw_NO 01.ac126523.svg";